export const ORIGIN = "https://profimy.app";
export function canonicalPath(pathname) {
  return pathname.replace(/\/+$/, "") || "/";
}
export function isPublicPath(pathname) {
  const path = canonicalPath(pathname);
  return path === "/" || path === "/blog" || /^\/blog\/[^/]+$/.test(path) || path === "/outils" || /^\/outils\/[^/]+$/.test(path);
}
function meta(attribute, key, value) {
  const matches = [...document.head.querySelectorAll(`meta[${attribute}="${key}"]`)];
  const element = matches.shift() || document.createElement("meta");
  element.setAttribute(attribute, key);
  element.content = value;
  if (!element.parentNode) document.head.appendChild(element);
  matches.forEach(node => node.remove());
}
export function applySEO({ pathname, title, description, article, indexable = true }) {
  const url = ORIGIN + canonicalPath(pathname);
  document.documentElement.lang = "fr";
  document.title = title;
  meta("name", "description", description);
  meta("name", "robots", indexable ? "index,follow,max-image-preview:large" : "noindex,follow");
  const links = [...document.head.querySelectorAll('link[rel="canonical"]')];
  const canonical = links.shift() || document.createElement("link");
  canonical.rel = "canonical";
  canonical.href = url;
  if (!canonical.parentNode) document.head.appendChild(canonical);
  links.forEach(node => node.remove());
  meta("property", "og:url", url);
  meta("property", "og:title", title);
  meta("property", "og:description", description);
  meta("property", "og:type", article ? "article" : "website");
  const image = article?.image || ORIGIN + "/og-image.png";
  meta("property", "og:image", image);
  meta("name", "twitter:title", title);
  meta("name", "twitter:description", description);
  meta("name", "twitter:image", image);
  const oldSchema = document.getElementById("profimy-article-schema");
  if (oldSchema) oldSchema.remove();
  if (article) {
    const schema = document.createElement("script");
    schema.id = "profimy-article-schema";
    schema.type = "application/ld+json";
    schema.textContent = JSON.stringify({
      "@context": "https://schema.org", "@type": "BlogPosting",
      headline: article.title, description, image,
      datePublished: article.date, mainEntityOfPage: url,
      author: { "@type": "Organization", name: "Equipe Profimy", url: ORIGIN },
      publisher: { "@type": "Organization", name: "Profimy", url: ORIGIN },
    });
    document.head.appendChild(schema);
  }
}
